export default {"src":"/_next/static/media/content-hub-door.04fc7e44.svg","height":287,"width":840,"blurWidth":0,"blurHeight":0};